module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074c7_banner_800x600.8a4b663d.png";